import { RouterProvider } from 'react-router'

import { Toaster } from 'src/core/components/sonner'
import router from 'src/routes/Router'

const App = () => {
	return (
		<>
			<RouterProvider router={router} />
			<Toaster />
		</>
	)
}

export default App
